import axios from "axios";
import { API_URL } from "./config";
import {getUrlParamQueries} from '../utils'

const api_url = API_URL;

export default {
  getEvents: () => {
    return axios
      .get(api_url + '/events')
      .then(response => response.data)
  },
  getDraws: () => {
    return axios
      .get(api_url + '/events/draw')
      .then(response => response.data)
  },
  getBetsHistory: async () => {
    return await axios
      .post(api_url + '/bets/history',
        { 'customer_id': getUrlParamQueries()['customer'] },
        {
          headers: {
            Authorization: getUrlParamQueries()['client_token']
          }
        }).then(response => {
          return response.data;
        });
  },
  picknow: async (request) => {
    return await axios
      .post(api_url + '/transaction/debit',
        request,
        {
          headers: {
            Authorization: getUrlParamQueries()['client_token']
          }
        }).then(response => {
          return response.data;
        });
  },
  translate: async (text,locale) => {
    return await axios
      .post(api_url + '/translate',
        {"text":text,"locale":locale}
        ).then(response => {
          return response.data;
        }).catch(e=>{
          return '';
        });
  },
  getTranslate: async (text,locale) => {
    return await axios
      .get(api_url + '/translate/get'
        ).then(response => {
          return response.data;
        }).catch(e=>{
          return '';
        });
  },
  getBalance: async () => {
    return await axios
      .post(api_url + '/balance',
        {"customers":[
          {"customer_id": getUrlParamQueries()['customer'],"currency": getUrlParamQueries()['currency']}
        ]},
        {
          headers: {
            Authorization: getUrlParamQueries()['client_token']
          }
        }).then(response => {
          return response.data;
        });
  },  
  getBalanceHistory: async () => {
    return await axios
      .post(api_url + '/balance/history',
        {"customer":
          {"id": getUrlParamQueries()['customer'],"currency": getUrlParamQueries()['currency']}
        },
        {
          headers: {
            Authorization: getUrlParamQueries()['client_token']
          }
        }).then(response => {
          return response.data;
        });
  },
  getBanners: async () => {
    return await axios
      .get(api_url + '/banners'
        ).then(response => {
          return response.data;
        }).catch(e=>{
          return '';
        });
  }
}


// WEBPACK FOOTER //
// ./api/index.js